import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySGAdherenceChart',
    label: 'Fidelity Adherence Chart',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
